import { render } from "./MPSVCard.vue?vue&type=template&id=1bc4ff26"
import script from "./MPSVCard.vue?vue&type=script&lang=js"
export * from "./MPSVCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__